import { lazyWithRetry } from 'components/lazyUtil.js'

const NotFound = lazyWithRetry(() => import('./../../../components/elements/errors/404.js'))

// IMPORTANT //
// In Future: whenever new route path is added ensure to update "validPaths" in /server/validRoutes.js
const routes = [
  {
    path: '/press',
    component: NotFound,
    is_private: false,
  },
  {
    path: '/404',
    component: NotFound,
    is_private: false,
  },
]

export default routes
